import { call, put, takeLatest } from 'redux-saga/effects';

import { MODAL_LOGIN } from '../../../constants/app';
import { userApi } from '../../../api';

import { updateQueryString } from '../../router/actions';
import { pushNotification } from '../../ui/actions';

import * as actions from './actions';

function* resendEmailConfirmation({ email }) {
  try {
    yield put({ type: actions.RESEND_EMAIL_CONFIRMATION_PENDING });
    const { status } = yield call(userApi.resendConfirmationEmail, { email });

    if (status === 200) {
      yield put({ type: actions.RESEND_EMAIL_CONFIRMATION_FULFILLED });
      yield put(updateQueryString({ modal: MODAL_LOGIN }));
      yield put(
        pushNotification({
          title: 'Request submitted successfully',
          description: 'If your account exists, you will receive an email shortly.',
          duration: 8,
          type: 'success',
        }),
      );
    }
  } catch (e) {
    yield put({ type: actions.RESEND_EMAIL_CONFIRMATION_REJECTED, payload: e });
  }
}

export function* watchResendEmailConfirmation() {
  yield takeLatest(actions.RESEND_EMAIL_CONFIRMATION, resendEmailConfirmation);
}
